import { Box, Heading, Text, Flex } from "@chakra-ui/react";
import React from "react";
import hero from "../../assets/images/hero.jpeg";
const HeroSection = () => {
  return (
    <Box
      id="story"
      w="90%"
      m="auto"
      py={{ base: 8, lg: 20 }}
      bgImage={hero}
      bgSize="cover"
      bgPosition="center"
      bgRepeat="no-repeat"
      borderTopLeftRadius={{ base: "12px", lg: "16px" }}
      borderBottomRightRadius={{ base: "12px", lg: "16px" }}
      borderTopRightRadius={{ base: "100px", lg: "120px" }}
      borderBottomLeftRadius={{ base: "12px", lg: "16px" }}
      position={"relative"}
      display="flex"
      flexDirection="column"
    >
      <Flex
        flexDirection={{ base: "column", lg: "row" }}
        flex="1"
        justifyContent={"center"}
        alignItems={"center"}
        px={{ base: 4, lg: 12 }}
      >
        <Box w="100%">
          <Flex direction="column" color="white">
            <Heading
              fontSize={{ base: "30px", sm: "38px", md: "52px" }}
              fontWeight="bold"
              lineHeight={{ base: "1.4", lg: "1.2" }}
            >
              <span style={{ fontSize: "26px" }}>
                {" "}
                FROM IDEATION TO CREATION{" "}
              </span>{" "}
              <br></br>
              <span style={{ color: "rgba(215, 255, 66, 1)" }}>
                WELCOME
              </span> TO{" "}
              <span style={{ color: "rgba(170, 87, 225, 1)" }}>
                INTERNATIONAL IDEATORS CUP{" "}
              </span>
            </Heading>
            <Text
              fontSize={{ base: "14px", sm: "16px", md: "18px" }}
              mt={{ base: 2, lg: 4 }}
            >
              The{" "}
              <span style={{ opacity: 1 }}>
                International Ideators Cup (IIC){" "}
              </span>
              is a global creative competition designed to push the boundaries
              of storytelling, writing, and filmmaking. Compete in thrilling
              rounds that challenge your ability to craft compelling narratives,
              build immersive worlds, and bring ideas to life through visual
              storytelling.
            </Text>
          </Flex>
        </Box>
      </Flex>
    </Box>
  );
};

export default HeroSection;
